// Shared tap-to-retry error state, generalized from the Reminders timeline
// tab's inline error block (ReminderTabs.tsx). Renders identically to that
// block by default: same className, same role/tabIndex wiring, same
// onClick/onKeyDown-fires-on-any-key behavior (the original block never
// filtered onKeyDown to Enter/Space, so this preserves that exactly for the
// timeline refactor to stay behavior-identical).
export type ErrorRetryProps = {
  message: string;
  onRetry: () => void;
  className?: string;
  'data-cy'?: string;
};

const DEFAULT_CLASSNAME = 'categories-grid dashboard-no-documents cursor-pointer';

export const ErrorRetry = ({
  message,
  onRetry,
  className = DEFAULT_CLASSNAME,
  'data-cy': dataCy,
}: ErrorRetryProps) => (
  <div
    className={className}
    data-cy={dataCy}
    onClick={onRetry}
    onKeyDown={onRetry}
    role="button"
    tabIndex={0}
  >
    {message}
  </div>
);

export default ErrorRetry;
